export default {
  computed: {
    websitefilestore: function() {
      return this.$store.getters['filestore/filestoreInfo']('website')
    },
    fileStore: function() {
      return this.$store.getters['filestore/filestoreInfo'](this.filestoreName)
    },
    editContentCreator: function() {
      if (this.$store.getters['user/isLoggedIn']) {
        return this.$store.state.flags['content-creator'] || false
      }
    },
    contentCreatorPermissions: function() {
      let permissions = { edit: false, editMenu: false, devel: false }
      if (this.$store.getters['user/isLoggedIn']) {
        if (this.$store.getters['user/checkPermissions']('vuejs menu devel edit')) {
          permissions.devel = true
          permissions.editMenu = true
        }
        if (this.$store.getters['user/checkPermissions']('vuejs menu edit')) {
          permissions.editMenu = true
        }
        if (this.$store.getters['user/checkPermissions']('update vuejs json data blob')) {
          permissions.edit = true
        }
      }
      return permissions
    }
  },
  methods: {
    saveBlob: function(name, data) {
      let saveData = JSON.parse(JSON.stringify(data.widget))
      this.$store.dispatch('blob/save', {blobID: name, blobData: saveData})
        .then(() => {
          data.cb()
        })
    },
    getBlobContents: function(name) {
      return this.$store.getters['blob/get'](name) || {}
    }
  }
}
